import {
  ScrollView,
  TouchableOpacity,
  TextInput,
  Modal,
  Image,
  Text,
  View,
} from "react-native";
import React from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { CommonButton } from "../../../../common/CommonButton";
import { AppScreens } from "../../../Utility/AppScreens";

export default function PurchaseSuccessModal({
  title = "Purchase successful",
  description = "You have successfully purchased a ticket",
  closePurchaseSuccess,
  closeButTicket,
  openPurchaseSuccess,
  token,
  item,
}) {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const attendeeCount = item.attendeeCount ? item.attendeeCount : 0;
  const ticketNumber = attendeeCount + 1;
  return (
    <Modal transparent={openPurchaseSuccess} visible={true}>
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_32, { flex: 1 }]}>
              {title}
            </Text>
            <TouchableOpacity
              onPress={() => {
                closePurchaseSuccess();
                closeButTicket(true);
              }}
              style={{
                backgroundColor: AppColors.gray_212222,
                width: 30,
                height: 30,
                borderRadius: 7,
                borderColor: AppColors.grayColor_393939,
                borderWidth: 1,
              }}
            >
              <Image
                source={AppImages.icCancel}
                style={{ height: 13, width: 15, margin: 5 }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
          <View
            style={{
              height: 2,
              backgroundColor: AppColors.gray_1E1E1E,
              marginTop: 22,
            }}
          />
          <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { marginTop: 30 }]}>
            {description} for the following event: {item.title}
          </Text>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-evenly",
              gap: 110,
            }}
          >
            <Text style={[AppFontStyle.REGULAR_ANYBODY_20, { marginTop: 35 }]}>
              Your Ticket
            </Text>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_15, { marginTop: 39 }]}>
              Ticket price : {token} tokens
            </Text>
          </View>
          <View
            style={{
              backgroundColor: AppColors.gray_1E1E1E,
              height: 166,
              borderRadius: 10,
              marginVertical: 10,
              flexDirection: "row",
              justifyContent: "space-evenly",
              gap: 50,
            }}
          >
            <Image
              source={AppImages.icTicket}
              style={{
                height: 52,
                width: 116,
                borderRadius: 10,
                marginVertical: 23,
                alignSelf: "center",
              }}
            />
            <View>
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_15, { marginTop: 58 }]}
              >
                Ticket number
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_28,
                  { marginTop: 10, textAlign: "center" },
                ]}
              >
                {ticketNumber}
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-evenly",
              gap: 15,
            }}
          >
            <CommonButton
              title="Back to dashboard"
              onTap={() => {
                navigation.dispatch(StackActions.popToTop());
                closePurchaseSuccess();
                closeButTicket(true);
              }}
              buttonStyle={styles.btnDashboard}
              textStyle={[
                AppFontStyle.BOLD_ANYBODY_12,
                { color: AppColors.appViolentColor_6D08C3 },
              ]}
            />
            <CommonButton
              title="Go to event"
              onTap={() => {
                closePurchaseSuccess();
                closeButTicket(true);
              }}
              buttonStyle={styles.btnWatchEvent}
              textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      backgroundColor: AppColors.black_121212,
      borderRadius: 10,
      borderWidth: 1,
      borderColor: AppColors.gray_9F9F9F,
      padding: 30,
      width: "32%",
      paddingHorizontal: 35,
      marginHorizontal: 40,
      marginVertical: 50,
      alignSelf: "center",
    },

    btnWatchEvent: {
      paddingVertical: 0,
      paddingHorizontal: 0,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 40,
      marginVertical: 20,
      borderRadius: 10,
      alignSelf: "center",
      flex: 1,
    },
    btnDashboard: {
      paddingVertical: 0,
      paddingHorizontal: 0,
      backgroundColor: AppColors.black_121212,
      borderWidth: 1,
      borderColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 40,
      marginVertical: 20,
      borderRadius: 10,
      alignSelf: "center",
      flex: 1,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.gray_9F9F9F,
        padding: 15,
        width: "97%",
        paddingHorizontal: 20,
        marginHorizontal: 40,
        marginVertical: 60,
        alignSelf: "center",
      },

      btnWatchEvent: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginVertical: 20,
        borderRadius: 10,
        alignSelf: "center",
      },
      btnDashboard: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        backgroundColor: AppColors.black_121212,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginVertical: 20,
        borderRadius: 10,
        alignSelf: "center",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.gray_9F9F9F,
        padding: 30,
        width: "65%",
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
      },

      btnWatchEvent: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginVertical: 20,
        borderRadius: 10,
        alignSelf: "center",
      },
      btnDashboard: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        backgroundColor: AppColors.black_121212,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginVertical: 20,
        borderRadius: 10,
        alignSelf: "center",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.gray_9F9F9F,
        padding: 30,
        width: "54%",
        paddingHorizontal: 28,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
      },

      btnWatchEvent: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginVertical: 20,
        borderRadius: 10,
        alignSelf: "center",
      },
      btnDashboard: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        backgroundColor: AppColors.black_121212,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginVertical: 20,
        borderRadius: 10,
        alignSelf: "center",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        backgroundColor: AppColors.black_121212,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.gray_9F9F9F,
        padding: 30,
        width: "45%",
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
      },

      btnWatchEvent: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginVertical: 20,
        borderRadius: 10,
        alignSelf: "center",
      },
      btnDashboard: {
        paddingVertical: 0,
        paddingHorizontal: 0,
        backgroundColor: AppColors.black_121212,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        marginVertical: 20,
        borderRadius: 10,
        alignSelf: "center",
      },
    },
  }
);
